import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ILoginService, LOGIN_SERVICE, LoginStore } from '@boxx/login-core';
import { ModalController } from '@ionic/angular';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.page.html',
  styleUrls: ['./delete-account.page.scss'],
})
export class DeleteAccountPage implements OnInit {
  codeForm: FormGroup | any;
  commentsForm: FormGroup | any;
  passForm: FormGroup | any;
  codeSent = false;
  hasError = false;
  step = 1;
  revealPassword = false;
  revealConfirmPassword = false;
  _previousEmail: string;
  _cleanEmail: string;

  passwordLength: boolean = false;
  passwordUppercase: boolean = false;
  passwordNumber: boolean = false;
  passwordSpecialCharacter: boolean = false;
  isPassrulesValid = false;
  isLoading = false;

  countdown: number = 120; 
  displayTime: string = '02:00';
  timer: any;
  isCounterfinished = false;

  constructor(
    @Inject(LOGIN_SERVICE) private loginService: ILoginService,
    private boxxUtils: BoxxUtilsService,
    private modalCtrl: ModalController,
    private router: Router,
    public loginStore: LoginStore
  ) {}

  ngOnInit() {
    this._cleanEmail = this._previousEmail;
    this._previousEmail = this.maskEmail(this._previousEmail);
    this.initForm();
    // this.passRecoveryForm = this.fb.group({
    //   email: [
    //     '',
    //     [Validators.required, Validators.pattern(APP_CONSTANTS.EMAILPATTERN)],
    //   ],
    // });
  }

  initForm() {
    this.codeForm = new FormGroup({
      code: new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4),
        Validators.pattern('^[0-9]{4}$')
      ])
    });

  
    this.commentsForm = new FormGroup({
      comments: new FormControl('', [ Validators.required])
    });

    this.passForm = new FormGroup({
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required)
    }, { validators: this.passwordMatchValidator });
  }

  passwordMatchValidator(form: FormGroup) {
    const newPassword = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { passwordMismatch: true };
  }

  sendCode(){
    this.boxxUtils.handleLoading(true);
    this.loginService.sendDeleteCode(this._cleanEmail)
      .subscribe({
        next: () => {
          this.codeSent = true;
          this.startCountdown();
          this.boxxUtils.handleLoading(false);
        },
        error: (error: any) => {
          console.log('error: ', error);
          this.boxxUtils.handleLoading(false);
        }
      });
  }

  maskEmail(email) {
    const [localPart, domain] = email.split('@');
    const visiblePart = localPart.slice(-3);
    const maskedEmail = `******${visiblePart}@${domain}`;
    return maskedEmail;
}

  validateCode(){
    this.hasError = false;
    this.isLoading = true;
    this.stopCountdown();
    let _formValue = this.codeForm.value;

    this.loginService.deleteUser(_formValue.code)
      .subscribe({
        next: (response: any) => {
          this.loginStore.logout();
          this.hasError = false;
          this.isLoading = false;
          this.step = 2;
        },
        error: (error: any) => {
          console.log('error: ', error);
          this.isLoading = false;
          this.hasError = true;
          this.step = 1;
        }
      });
  }

  revealPass(inputNumber: number){
    if(inputNumber === 1){
      this.revealPassword = !this.revealPassword;
    }
    else{
      this.revealConfirmPassword = !this.revealConfirmPassword;
    }
  }


  async close(){
    this.modalCtrl.dismiss();
  }

  async finish(){
    try {
      let topModal = await this.modalCtrl.getTop();
      while (topModal) {
        await this.modalCtrl.dismiss();
        topModal = await this.modalCtrl.getTop();
      }
      this.router.navigateByUrl('/onboarding/user-login');
    } catch (error) {
      console.error('Error closing modals:', error);
    }
  }

  startCountdown() {
    this.resetCounter();
    this.isCounterfinished = false; // Reiniciamos la variable al iniciar el contador

    this.timer = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.updateDisplayTime();
      } else {
        this.stopCountdown(); // Detiene el contador cuando llega a 0
      }
    }, 1000);
  }

  stopCountdown() {
    clearInterval(this.timer);
    this.isCounterfinished = true;
  }

  private updateDisplayTime() {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    this.displayTime = `${this.padZero(minutes)}:${this.padZero(seconds)}`;
  }

  private padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  private resetCounter() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.countdown = 120;
    this.updateDisplayTime();
  }
}
